import React, { Component } from "react";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import lightGreen from "@material-ui/core/colors/lightGreen";

import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import firebase from "../../../../firebase/firebase";

import { question } from "react-icons-kit/icomoon/question";

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textFieldSmall: {
    width: 100
  },
  textFieldFull: {
    width: 230
  },
  dialogContent: {
    padding: 14
  },
  //style for font size
  resize: {
    fontSize: 50
  },
  colorSwitchBase: {
    color: {},
    "&$colorChecked": {
      color: lightGreen[500],
      "& + $colorBar": {
        backgroundColor: lightGreen[500]
      }
    }
  },
  colorBar: {},
  colorChecked: {}
};

const Container = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;

  @media (max-width: 400px) {
    grid-column-gap: 0.5rem;
    grid-row-gap: 2rem;
  }
`;

const FullContainer = styled.div`
  grid-column: 1 / -1;
`;

const LanguageContainer = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(3, minmax(min-content, 1fr));

  @media (max-width: 400px) {
    grid-template-columns: repeat(2, min-content);
  }
`;

const OtherContainer = styled.div`
  grid-column: 2 / -1;

  @media (max-width: 400px) {
    grid-column: 1 / -1;
  }
`;

const Title = styled.div`
  grid-column: 1 / -1;
  margin-top: 1rem;
`;

const StyledButton = styled(Button)`
  &&& {
    grid-column: 2 / 3;
    justify-self: center;
  }
`;

const ButtonContainer = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding-bottom: 2rem;
`;

const StyledInput = styled.input`
  transform: translateY(10px);
  border: none;
  border-bottom: 2px solid gray;
`;

class PioneerNew extends Component {
  state = {
    firstName: "",
    lastName: "",
    email: "",
    birthDate: null,
    city: "",
    country: "",
    education: "",
    german: false,
    english: false,
    french: false,
    otherLanguageChecked: false,
    otherMediaChecked: false,
    otherLanguage: "",
    follower: 0,
    facebook: false,
    instagram: false,
    twitter: false,
    youtube: false,
    otherSocialMedia: "",
    isUploading: false,
    progress: 0,
    imageUrl: "",
    image: null
  };

  updateInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleChecked = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  updateImageChange = e => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      this.setState(() => ({ image }));
    }
  };

  uploadImage = e => {
    e.preventDefault();
    const { image } = this.state;
    const storage = firebase.storage();
    const uploadTask = storage.ref(`images/${image.name}`).put(image);
    uploadTask.on(
      "state_changed",
      snapshot => {
        // progress
      },
      error => {
        console.log(error);
      },
      () => {
        // complete
        storage
          .ref("images")
          .child(image.name)
          .getDownloadURL()
          .then(url => this.setState({ imageUrl: url }));
      }
    );
  };

  addPioneer = e => {
    e.preventDefault();
    const database = firebase.database();
    const { image } = this.state;
    const storage = firebase.storage();
    const uploadTask = storage
      .ref(`images/${this.state.lastName}/${image.name}`)
      .put(image);
    uploadTask.on(
      "state_changed",
      snapshot => {
        // progress
      },
      error => {
        console.log(error);
      },
      () => {
        // complete
        storage
          .ref("images")
          .child(image.name)
          .getDownloadURL()
          .then(url => this.setState({ imageUrl: url }));
      }
    );
    database.ref("Pioneers").push({
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      birthDate: this.state.email,
      city: this.state.city,
      country: this.state.country,
      education: this.state.education,
      german: this.state.german,
      english: this.state.english,
      french: this.state.french,
      otherLanguage: this.state.otherLanguage,
      otherMediaChecked: this.state.otherMediaChecked,
      follower: this.state.follower,
      facebook: this.state.facebook,
      instagram: this.state.instagram,
      twitter: this.state.twitter,
      youtube: this.state.youtube,
      otherSocialMedia: this.state.otherSocialMedia,
      imageUrl: this.state.imageUrl
    });
    this.setState({
      firstName: "",
      lastName: "",
      email: "",
      birthDate: null,
      city: "",
      country: "",
      education: "",
      german: false,
      english: false,
      french: false,
      otherLanguageChecked: false,
      otherMediaChecked: false,
      otherLanguage: "",
      follower: 0,
      facebook: false,
      instagram: false,
      twitter: false,
      youtube: false,
      otherSocialMedia: "",
      isUploading: false,
      imageUrl: "",
      image: null
    });
  };
  render() {
    const { classes } = this.props;
    return (
      <Container onSubmit={this.addPioneer}>
        <TextField
          type="text"
          name="firstName"
          value={this.state.firstName}
          onChange={this.updateInput}
          label="First Name"
          className={classes.textFieldSmall}
        />
        <TextField
          type="text"
          name="lastName"
          value={this.state.lastName}
          onChange={this.updateInput}
          label="Last Name"
          className={classes.textFieldSmall}
        />
        <FullContainer>
          <TextField
            fullWidth
            type="email"
            name="email"
            value={this.state.email}
            onChange={this.updateInput}
            label="Email"
            className={classes.textFieldFull}
          />
        </FullContainer>
        <FullContainer>
          <TextField
            id="date"
            name="birthDate"
            value={this.state.birthDate}
            onChange={this.updateInput}
            label="Birthday"
            type="date"
            defaultValue="2017-05-24"
            InputLabelProps={{
              shrink: true
            }}
          />
        </FullContainer>
        <TextField
          type="text"
          name="city"
          value={this.state.city}
          onChange={this.updateInput}
          label="City"
          className={classes.textFieldSmall}
        />
        <TextField
          type="text"
          name="country"
          value={this.state.country}
          onChange={this.updateInput}
          label="Country"
          className={classes.textFieldSmall}
        />
        <FullContainer>
          <TextField
            fullWidth
            type="text"
            name="education"
            value={this.state.education}
            onChange={this.updateInput}
            label="Education / Profession"
            className={classes.textFieldFull}
          />
        </FullContainer>
        <Title>Languages</Title>
        <LanguageContainer>
          <FormControlLabel
            control={
              <Switch
                onChange={this.handleChecked("german")}
                checked={this.state.german}
                value="german"
                classes={{
                  switchBase: classes.colorSwitchBase,
                  checked: classes.colorChecked,
                  bar: classes.colorBar
                }}
              />
            }
            label="German"
          />
          <FormControlLabel
            control={
              <Switch
                onChange={this.handleChecked("english")}
                checked={this.state.english}
                value="english"
                classes={{
                  switchBase: classes.colorSwitchBase,
                  checked: classes.colorChecked,
                  bar: classes.colorBar
                }}
              />
            }
            label="English"
          />
          <FormControlLabel
            control={
              <Switch
                onChange={this.handleChecked("french")}
                checked={this.state.french}
                value="french"
                classes={{
                  switchBase: classes.colorSwitchBase,
                  checked: classes.colorChecked,
                  bar: classes.colorBar
                }}
              />
            }
            label="French"
          />
          <FormControlLabel
            control={
              <Switch
                onChange={this.handleChecked("otherLanguageChecked")}
                checked={this.state.otherLanguageChecked}
                value="otherLanguageChecked"
                classes={{
                  switchBase: classes.colorSwitchBase,
                  checked: classes.colorChecked,
                  bar: classes.colorBar
                }}
              />
            }
            label="Other"
          />
          {this.state.otherLanguageChecked ? (
            <OtherContainer>
              <StyledInput
                type="text"
                name="otherLanguage"
                value={this.state.otherLanguage}
                onChange={this.updateInput}
                label="otherLanguage"
              />
            </OtherContainer>
          ) : null}
        </LanguageContainer>
        <Title>Social Media Accounts</Title>
        <FormControlLabel
          control={
            <Switch
              onChange={this.handleChecked("facebook")}
              checked={this.state.facebook}
              value="facebook"
              classes={{
                switchBase: classes.colorSwitchBase,
                checked: classes.colorChecked,
                bar: classes.colorBar
              }}
            />
          }
          label="Facebook"
        />
        <FormControlLabel
          onChange={this.updateInput}
          control={
            <Switch
              onChange={this.handleChecked("instagram")}
              checked={this.state.instagram}
              value="instagram"
              classes={{
                switchBase: classes.colorSwitchBase,
                checked: classes.colorChecked,
                bar: classes.colorBar
              }}
            />
          }
          label="Instagram"
        />
        <FormControlLabel
          control={
            <Switch
              onChange={this.handleChecked("twitter")}
              checked={this.state.twitter}
              value="twitter"
              classes={{
                switchBase: classes.colorSwitchBase,
                checked: classes.colorChecked,
                bar: classes.colorBar
              }}
            />
          }
          label="twitter"
        />
        <FormControlLabel
          control={
            <Switch
              onChange={this.handleChecked("youtube")}
              checked={this.state.youtube}
              value="youtube"
              classes={{
                switchBase: classes.colorSwitchBase,
                checked: classes.colorChecked,
                bar: classes.colorBar
              }}
            />
          }
          label="youtube"
        />
        <FormControlLabel
          control={
            <Switch
              onChange={this.handleChecked("otherMediaChecked")}
              checked={this.state.otherMediaChecked}
              value="otherMediaChecked"
              classes={{
                switchBase: classes.colorSwitchBase,
                checked: classes.colorChecked,
                bar: classes.colorBar
              }}
            />
          }
          label="Other"
        />
        {this.state.otherMediaChecked ? (
          <OtherContainer>
            <StyledInput
              type="text"
              name="otherSocialMedia"
              value={this.state.otherSocialMedia}
              onChange={this.updateInput}
              label="otherSocialMedia"
            />
          </OtherContainer>
        ) : null}
        <FullContainer>
          <TextField
            fullWidth
            type="number"
            name="follower"
            value={this.state.follower}
            onChange={this.updateInput}
            label="Number Followers"
            className={classes.textFieldFull}
          />
        </FullContainer>
        <FullContainer>
          <Title>Picture from You</Title>
          <TextField
            fullWidth
            type="file"
            name="image"
            onChange={this.updateImageChange}
            className={classes.textFieldFull}
          />
        </FullContainer>
        <ButtonContainer>
          <StyledButton variant="contained" type="submit">
            Submit
          </StyledButton>
        </ButtonContainer>
      </Container>
    );
  }
}

export default withStyles(styles)(PioneerNew);



// WEBPACK FOOTER //
// ./src/components/Pages/Audition/Content/PioneerNew.js